import { rtDigits } from "../utilities/constants.js";

export function roundRealThreshold(val, digits = rtDigits) {
  return parseFloat(val.toPrecision(digits));
}
